const SELECTOR_LESSON_LIST = '.js-lessons-list';
const SELECTOR_LESSON_GROUP = '.js-lesson-group';
const SELECTOR_BTN = '.js-lesson-collapse-btn';
const SELECTOR_LESSON_CARD_LINK = '.bm-card-link';

let expandedGroup = 0;

export default function setupLessonsListCollapse() {
  $(document).on('turbolinks:load', () => {
    lessonsListCollapseInit();
  });
  lessonsListCollapseInit();

  function lessonsListCollapseInit() {
    if ($(SELECTOR_LESSON_LIST).length) {
      const $lessonList = $(SELECTOR_LESSON_LIST);
      const $lessonGroups = $(SELECTOR_LESSON_GROUP);
      collapseAllGroups($lessonList, $lessonGroups);

      $(SELECTOR_BTN).on('click', e => {
        $.ajax({
          type: 'POST',
          url: '/show_more_clicked',
          data: { course_id: $(SELECTOR_BTN).attr('id') },
          dataType: 'json'
        });

        collapseDecide($lessonList, $lessonGroups);
        $(e.target).blur();
      });

      $(document).on('turbolinks:before-cache', () => {
        collapseAllGroups($lessonList, $lessonGroups);
      });
    }
  }
}

function collapseDecide($lessonList, $lessonGroups) {
  if (expandedGroup < $lessonGroups.length) {
    expandNextGroup($lessonList, $lessonGroups);
  } else {
    collapseAllGroups($lessonList, $lessonGroups, true);
  }
}

function collapseAllGroups($lessonList, $lessonGroups, transition = false) {
  if (transition) {
    // Scroll page to top of lessons list
    const offset = $lessonList.offset().top;
    const headerHeight = $('header').height() + 20;
    $('html, body').animate({ scrollTop: offset - headerHeight });

    // Collapse all lesson groups
    $lessonGroups.animate(
      {
        height: 0
      },
      400,
      function() {
        $lessonGroups.addClass('bm-lessons-list__group--hidden');
      }
    );
    $lessonList
      .find(SELECTOR_LESSON_CARD_LINK)
      .eq(0)
      .focus();
  } else {
    $lessonGroups.height('0').addClass('bm-lessons-list__group--hidden');
  }
  $lessonGroups.find(SELECTOR_LESSON_CARD_LINK).attr('tabindex', '-1');
  $lessonList.attr('data-expanded-to', '0');
  expandedGroup = 0;
  $(SELECTOR_BTN)
    .attr({ 'aria-expanded': 'false', 'aria-label': 'Show 5 more lessons' })
    .find('span')
    .text('Show More');
  $lessonList.attr('aria-expanded', 'false');
}

function expandNextGroup($lessonList, $lessonGroups) {
  const $group = $lessonGroups.eq(expandedGroup);

  // Add disabled class to prevent early hover states
  $group.find(SELECTOR_LESSON_CARD_LINK).addClass('bm-disabled');

  $group.animate(
    {
      height: $lessonGroups[expandedGroup].scrollHeight
    },
    400,
    function() {
      $(this)
        .height('auto')
        .removeClass('bm-lessons-list__group--hidden');
      $group.find(SELECTOR_LESSON_CARD_LINK).removeClass('bm-disabled');
      $group
        .find(SELECTOR_LESSON_CARD_LINK)
        .eq(0)
        .focus();
    }
  );

  $group.find(SELECTOR_LESSON_CARD_LINK).attr('tabindex', '0');
  expandedGroup++;
  $lessonList.attr('data-expanded-to', expandedGroup);

  if ($lessonGroups.length === expandedGroup) {
    $(SELECTOR_BTN)
      .attr({ 'aria-expanded': 'true', 'aria-label': 'Collapse lessons' })
      .find('span')
      .text('Show Less');
    $lessonList.attr('aria-expanded', 'true');
  }
}
